import {
  MessageCircle, PenTool, Wallet, Scissors, ShieldCheck, Truck, Eye,
} from "lucide-react";

export const ICONS = {
  MessageCircle, PenTool, Wallet, Scissors, ShieldCheck, Truck, Eye,
};
